import React, { useState } from 'react';
import { CSSProperties } from '@material-ui/styles';
import RcTooltip from 'rc-tooltip';
import classNames from 'classnames';
import styles from '../styles/tooltip.module.scss';
import 'rc-tooltip/assets/bootstrap.css';

type Trigger = 'hover' | 'click' | 'focus';
export type TooltipPlacement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';

export default function Tooltip(props: {
  overlay: React.ReactNode;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  children?: React.ReactElement;
  trigger?: Trigger | Trigger[];
  style?: CSSProperties;
}) {
  // В библиотеке rc-tooltip есть проблема с opacity
  // opacity используется для анимации попапа и когда попап полностью показывается, то opacity установлен на .8 а не на 0.1
  // Невозможно поменять прозрачность на 1 через css потому что либо попап будет всегда проявлен, либо ломается анимация
  // Поэтому вот такой вот костыль: привязка класса только после полного отображения попапа
  const [visibleClass, setVisibleClass] = useState(false);
  return (
    <RcTooltip
      placement={props.placement || 'top'}
      trigger={props.trigger || 'hover'}
      overlayClassName={classNames(props.overlayClassName, styles.overlay, {
        [styles.noTransparentClass]: visibleClass,
      })}
      overlay={props.overlay}
      destroyTooltipOnHide={true}
      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
      mouseEnterDelay={0.1}
      onPopupAlign={() => setVisibleClass(true)}
    >
      {props.children}
    </RcTooltip>
  );
}
